import { api } from "#app/http/api";

export const completeSetup = async () => {
  const response = await api.company.completeSetup.mutation({
    body: undefined,
  });

  if (response.status !== 200) {
    throw new Error("Failed to complete company setup");
  }

  return response.body;
};
